import { useContext } from 'react';
import { PlateInteractionDispatch } from './PlateSelectionProvider';

export default function usePlateEditorDispatch(){

  const onEvent = useContext(PlateInteractionDispatch);

  return onEvent;


}
